import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NotificationCloudComponent } from './notification-cloud.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [
    NotificationCloudComponent,
  ],
  exports: [
    NotificationCloudComponent,
  ],
})
export class NotificationCloudModule { }
